import { useMutation } from "react-query";
import { getCarrierForEdit } from "../../../../actions/CarrierAgreementMgmt/Carrier";
export const useGetCarrierForEdit = () => {
  return useMutation(getCarrierForEdit);
};
